module.exports = __webpack_public_path__ + "img/9.a5fa2743.png";